export default {
  name: 'marking--documentType',
};